export type TherapyFilters = {
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  status: string;
  paymentStatus: string;
  payoutStatus: string;
};

export const ITEMS_PER_PAGE = 20;
